module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/career_pass_sm-b3f24fb87a5ec3fd3cde983a48569c7b.svg";